import React, { useEffect } from "react";
import { useRef } from "react";
import { fabric } from "fabric";

const AvatarCanvas = ({ file, setGeneratedImage }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!!file) {
      const reader = new FileReader();
      let canvas;

      reader.onload = function (event) {
        const img = new Image();
        img.onload = function () {
          const canvasElement = canvasRef.current;
          canvas = new fabric.Canvas(canvasElement);
          let width = img.width;
          let height = img.height;

          const scale = Math.min(500 / img.width, 500 / img.height);
          if (width > 500 || height > 500) {
            width = width * scale;
            height = height * scale;
          }

          canvas.setDimensions({
            width: width,
            height: height,
          });
          return fabric.Image.fromURL(img.src, (uploadImg) => {
            uploadImg.top = 0;
            uploadImg.left = 0;

            uploadImg.crossOrigin = "Anonymous";
            if (uploadImg.width > 500 || uploadImg.height > 500) {
              uploadImg.scale(scale);
            }
            canvas.add(uploadImg);
            canvas.renderAll();

            const result = canvas.toDataURL({
              top: 0,
              left: 0,
            });
            setGeneratedImage(result);
          });
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);

      return () => {
        if (canvas) {
          canvas.dispose();
        }
      };
    }
  }, [file]);

  return <canvas ref={canvasRef} />;
};

export default AvatarCanvas;
